import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-pause-icon',
  templateUrl: './pause-icon.component.html',
  styleUrls: ['./pause-icon.component.scss'],
})
export class PauseIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
